var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortArrowsAsc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.293 23.943C16.6835 23.5524 17.3167 23.5524 17.7072 23.943L19.7001 25.9359L21.693 23.943C22.0835 23.5524 22.7167 23.5524 23.1072 23.943C23.4978 24.3335 23.4978 24.9667 23.1072 25.3572L20.4072 28.0572C20.0167 28.4477 19.3835 28.4477 18.993 28.0572L16.293 25.3572C15.9025 24.9667 15.9025 24.3335 16.293 23.943Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1071 16.4071C22.7166 16.7976 22.0834 16.7976 21.6929 16.4071L19.7 14.4142L17.7071 16.4071C17.3166 16.7976 16.6834 16.7976 16.2929 16.4071C15.9024 16.0166 15.9024 15.3834 16.2929 14.9929L18.9929 12.2929C19.3834 11.9024 20.0166 11.9024 20.4071 12.2929L23.1071 14.9929C23.4977 15.3834 23.4977 16.0166 23.1071 16.4071Z",
    fill: "#2897FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrowsAsc);
export default __webpack_public_path__ + "static/media/sort-arrows-asc.355d714f2493bc12f9251b2f4f6c70b2.svg";
export { ForwardRef as ReactComponent };